import React from "react";

export const ProjectHead = () => {
  return (
    <>
      <div className="mx-auto flex max-w-[58rem] flex-col space-y-3 sm:text-center sm:flex sm:py-10 xs:px-4 xs:pt-5 xs:pb-0">
        <span className="font-bold text-3xl sm:text-3xl md:text-6xl text-white">
          Projects
        </span>

        <p className="max-w-[95%] leading-normal text-muted-foreground sm:text-lg sm:leading-7 text-gray-300">
          Insights into my technical expertise and creativity 
        </p>
      </div>
    </>
  );
};
